import React from 'react';
import './mbko.css'
import img1 from '../style/list01.png'
import img2 from '../style/list02.png'
import img3 from '../style/list03.png'
import img4 from '../style/list04.png'
import img5 from '../style/list05.png'
import img6 from '../style/list06.png'
import img7 from '../style/list07.png'
import img8 from '../style/list08.png'
import img9 from '../style/list09.png'
import img10 from '../style/list10.png'
import img11 from '../style/list11.png'
import img12 from '../style/title_small.png'
import img13 from '../style/back-btn.png'
import { Link } from 'react-router-dom';
import { useEffect,useState } from 'react';
import Papa from 'papaparse' ;
import axios from 'axios';

import csvString from './data/기즈모.csv';

function GIZ(props) {

    function convertCSVStringToList(csvString) {
        console.log(csvString)
        const { data } = Papa.parse(csvString);
        console.log(data)
        return data;
    }
    const [dataList,setDataList] = useState([]);


    useEffect(() => {
        window.scrollTo(0, 0); // 스크롤 위치를 (0, 0)으로 조정

        axios.get(csvString).then(res=>{
            setDataList(convertCSVStringToList(res.data));
        })
      }, []);
    
    return (
        <>
            <div className='bg-color'>
                <div className="background-image container container1">
                    <div className="GIZ-image">
                         <div className='back-btn'>
                    <Link to="/mbko" style={{textDecoration:'none'}}>
                            {/* <img className='back-btn' src={img13}>

                            </img> */}
                        　　　　　　</Link>
                        </div>
                        <div className='game-top'>
                        <p style={{marginBottom:10}}>
                        <strong>종목: 기즈모 &#40;일반부&#41;</strong>
                        </p>

                        <p style={{marginBottom:0}}>
                            <strong>· 예선 안내</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            예선장소: 본 페이지 맨 아래 리스트 참고
                            </p>
                            <p style={{marginBottom:0}}>
                            참가비: 예선 개최지 문의
                            </p>
                            <p style={{marginBottom:0}}>
                            신청방법: 원하는 예선 개최지에 연락 또는 방문신청
                            </p>
                            <p style={{marginBottom:0}}>
                            예선시상: 1위·2위 - 캣레이디 / &#40;사&#41;한국브레인스포츠연맹 상장 / 본선진출권
                            </p>
                            <p style={{marginBottom:30}}>
                            *본선진출권은 개최지마다 수량이 다릅니다. 정확한 순위는 개최지에 문의 부탁드립니다.
                            </p>

                        <p style={{marginBottom:0}}>
                            <strong>· 본선 안내</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            본선일시: 2023년 8월 19일 &#40;토&#41; 오전10시
                            </p>
                            <p style={{marginBottom:0}}>
                            본선장소: 수원컨벤션센터 1층 1대회장
                            </p>
                            <p style={{marginBottom:30}}>
                            진행방식: 2라운드진행
                            </p>

                            <p style={{marginBottom:0}}>
                            <strong>· 결승 및 순위결정전 안내</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            일시: 본선 당일 오후12시 &#40;동시진행&#41;
                        </p>
                        <p style={{marginBottom:0}}>
                            내용: 결승 - 1~4위전 / 순위결정전 - 5~8위전
                        </p>
                        <p style={{marginBottom:30}}>
                            장소: 결승 - 중계석 / 순위결정전 - 1대회장
                        </p>

                        <p style={{marginBottom:0}}>
                        <strong>· 본선운영방식</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            　- 전원 2라운드 진행 후 승점 등의 기준으로 순위 결정
                        </p>
                        <p style={{marginBottom:10}}>
                            　- &#40;사&#41;한국브레인스포츠연맹이 정한 승점 산정방식을 적용함
                        </p>
                            <table className='table1'>
                                <caption className='caption1'   style={{color:"white" }}>《 KbSF 승점 산정 방식 》</caption  >
                                <tr>
                                    <th className='th1'>플레이인원</th>
                                    <th className='th1'>1위</th>
                                    <th className='th1'>2위</th>
                                    <th className='th1'>3위</th>
                                    <th className='th1'>4위</th>

                                </tr>                                
                                <tr>
                                    <td  className='td1'>4인전</td>
                                    <td  className='td1'>10점</td>
                                    <td  className='td1'>6점</td>
                                    <td  className='td1'>4점</td>
                                    <td  className='td1'>2점</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>3인전</td>
                                    <td  className='td1'>9점</td>
                                    <td  className='td1'>5점</td>
                                    <td  className='td1'>3점</td>
                                    <td  className='td1'>-</td>
                                </tr>
                                
                                </table>
                        <p style={{marginBottom:20}}>
                        </p>

                        <p style={{marginBottom:0}}>
                            <strong>· 결승 및 순위결정전 진행방식</strong>
                            </p>
                        <p style={{marginBottom:0}}>
                            　- 1~4위 4인은 최종 결승전에 진출하며 경기는 보드라이브 유튜브 채널에서 생중계 함
                        </p>
                        <p style={{marginBottom:30}}>
                            　- 5~8위 4인은 순위 결정전을 진행하여 랭킹으로 기록 됨
                        </p>

                        <p style={{marginBottom:10}}>
                            <strong>· 본선 시상 안내</strong>
                            </p>
                        <table className='table1'>
                                <tr>
                                    <th style={{width:"50px"}}>등수</th>
                                    <th className='th1'>시상내용</th>
                                </tr>                                
                                <tr>
                                    <td  className='td1'>1등</td>
                                    <td  className='td1'>보드엠 15만원 상품권, 우승 트로피, 상장, 메달</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>2등</td>
                                    <td  className='td1'>판타스틱팩토리 풀 확장 &#40;본판+확장2개+플레이매트+프로모션카드&#41;, 상장, 메달</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>3등</td>
                                    <td  className='td1'>오리진스 본판+확장, 상장, 메달</td>
                                </tr>
                                <tr>
                                    <td  className='td1'>4등</td>
                                    <td  className='td1'>QE, 상장, 메달</td>
                                </tr>
                               
                                </table>

                                <p style={{marginBottom:30}}>
                            ※ 결승 진출자 전원 선수 티셔츠 제공
                        </p>

                        <p style={{marginBottom:10}}>
                            <strong>· 경기 진행 세부 사항</strong>
                            </p>
                        
                        <p style={{marginBottom:10}}>
                            　- 어떤 시점이든 특정 선수의 에너지 볼 저장 한도가 넘은 것을 발견한다면, 즉시 경기를 일시 중지한 후 저장된 구슬 중 하나를 해당 플레이어가 골라 버립니다. 이렇게 버려진 구슬은 즉시 에너지 분배기에 넣습니다.
                        </p>
                        <p style={{marginBottom:10}}>
                            　- 어떤 시점이든 특정 선수의 수집 저장 한도가 넘은 것을 발견하였다면, 경기를 일시 중지한 후 수집된 카드 중 한 장을 해당 플레이어가 골라 카드더미 맨 밑에 놓습니다.
                        </p>
                        <p style={{marginBottom:30}}>
                            　- 에너지 레일에서 잘못된 구슬이 이탈되었다면, 즉시 이탈한 구슬을 에너지 분배기에 넣습니다. 
                        </p>


                        <p style={{marginBottom:0}}>
                            <strong>· 경기 순위 결정 방법</strong>
                            </p>
                            <p style={{marginBottom:0}}>
                            아래 항목을 비교하여 순위를 결정합니다.
                            </p>
                            <p style={{marginBottom:0}}>
                            　· 해당 경기의 점수가 더 높은 사람
                            </p>
                            <p style={{marginBottom:0}}>
                            　· 동률일 경우 제작된 기즈모&#40;카드&#41;가 더 많은 사람
                            </p>
                            <p style={{marginBottom:0}}>
                            　· 그것마저 동률일 경우 에너지 저장 링에 저장된 에너지 구슬 개수가 많은 사람
                            </p>
                            <p style={{marginBottom:30}}>
                            　· 그것마저 동률일 경우 플레이 순서가 더 뒤인 사람이 승리 합니다.
                            </p>


                            <p style={{marginBottom:0}}>
                            <strong>· 예선 순위 결정 방법</strong>
                            </p>
                            <p style={{marginBottom:0}}>
                            　· KbSF가 정한 승점의 합이 높은 사람 
                            </p>
                            <p style={{marginBottom:0}}>
                            　· 동률일 경우 모든 경기 점수의 총합이 높은 사람
                            </p>
                            <p style={{marginBottom:0}}>
                            　· 그것마저 동률일 경우 제작된 기즈모&#40;카드&#41;가 더 많은 사람
                            </p>
                            <p style={{marginBottom:30}}>
                            　· 그것마저 동률일 경우 에너지 저장 링에 저장된 에너지 구슬 개수의 총합이 많은 사람이 승리 합니다.
                            </p>



                            <p style={{marginBottom:10}}>
                            <strong>· 예선개최지 리스트</strong>
                            </p>

                            {
                                dataList.map(m=><>
                                    <table className='table1'>
                                        <tr>
                                            <th style={{width:"80px"}}>개최지명</th>
                                            <th className='th1'>{m[0]}</th>
                                        </tr>                                
                                        <tr>
                                            <td  className='td1'>주소</td>
                                            <td  className='td2'>{m[2]}</td>
                                        </tr>
                                        <tr>
                                            <td  className='td1'>연락처</td>
                                            <td  className='td2'>{m[1]}</td>
                                        </tr>
                                        <tr>
                                            <td  className='td1'>대회날짜</td>
                                            <td  className='td2'>{m[3]} {m[4]}</td>
                                        </tr>
                                    
                                    </table>

                                    <p></p>
                                </>)
                            }
                        </div>
                    </div>
                </div>

                <div className='bottom1 container container1'>
                    <div className='bottom container container1'>
                    </div>

                </div>
            </div>
        </>


    );
}

export default GIZ;